import { rest } from "msw";
import { apiUrl } from "features/configure";
import {
  tags,
  onchainData,
  entity,
  teamMembers,
  userInfo,
  widgetConfig,
} from "./data/MockEntity";
const validWallets = [
  "0x16b85B41868b54913cBF939f0e5E3164C3d4036C",
  "0x67f40De70D441Cd7aE94E2DF3C3e4bb239019032",
  "0xBAcf897c6E9ADAc15299081Ceb8d25d23d82d39E",
  "0xa4B48F10220b39F70C357d1666d733146b1D8955",
  "0xAAF59Ff6464eb8Aa358919329fD5E7B50948fa55",
  "0x1a707d5935aed56e0C61D85E895ac7160758F856",
];

const getStatsCount = rest.get(
  `${apiUrl}/api/manage/count`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        ticket: {
          New: 4,
          Done: 3,
          Ongoing: 0,
          All: 7,
        },
        campaign: {
          All: 6,
          Draft: 2,
          Scheduled: 0,
          Ongoing: 0,
          Done: 4,
        },
      })
    );
  }
);

const getTicketTypes = rest.get(
  `${apiUrl}/api/manage/ticketType/:entityName`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json([
        {
          _id: "674d60d7ec54f17a8731839b",
          name: "General",
          index: 1,
          hasTicket: false,
        },
        {
          _id: "674d60d7ec54f17a873183ab",
          name: "Bug Report",
          index: 2,
          hasTicket: false,
        },
        {
          _id: "674d60d7ec54f17a873183b8",
          name: "Partnership Request",
          index: 3,
          hasTicket: false,
        },
      ])
    );
  }
);

const getTags = rest.get(
  `${apiUrl}/api/manage/tags/:entityName/user`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(tags));
  }
);

const getOnchainData = rest.get(
  `${apiUrl}/api/manage/onchainData/:entityName`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(onchainData));
  }
);

const getAuthCheck = rest.get(
  `${apiUrl}/api/session/authCheck`,
  (req, res, ctx) => {
    const accessToken = localStorage.getItem("access_token");
    if (accessToken === "DemoSite") {
      return res(ctx.status(200), ctx.json({ authorized: true }));
    }
    return res(ctx.status(200), ctx.json({ authorized: false }));
  }
);

const getAuthInfo = rest.get(
  `${apiUrl}/api/session/admin/info`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(userInfo));
  }
);

const getNonce = rest.get(`${apiUrl}/api/session/nonce`, (req, res, ctx) => {
  return res(ctx.status(200), ctx.json("12345678"));
});

const signInTeamAddress = rest.post(
  //solana, aptos
  `${apiUrl}/api/session/sign-in/team/address`,
  (req, res, ctx) => {
    const { address } = req.body;
    if (!validWallets.includes(address)) {
      return res(
        ctx.status(200),
        ctx.json({ authorized: false, error: "User not found." })
      );
    }
    return res(ctx.status(200), ctx.json({ accessToken: "DemoSite" }));
  }
);

const signInTeam = rest.post(
  //evm
  `${apiUrl}/api/session/sign-in/team`,
  (req, res, ctx) => {
    const { address } = req.body;
    if (!validWallets.includes(address)) {
      return res(
        ctx.status(200),
        ctx.json({ authorized: false, error: "User not found." })
      );
    }
    return res(ctx.status(200), ctx.json({ accessToken: "DemoSite" }));
  }
);

const getEntityEcosystem = rest.get(
  `${apiUrl}/api/manage/entityEcosystem`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json("evm"));
  }
);
const getEntityConfig = rest.get(
  `${apiUrl}/api/manage/entityConfig`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(entity));
  }
);

const getEntityTeam = rest.get(`${apiUrl}/api/manage/team`, (req, res, ctx) => {
  return res(ctx.status(200), ctx.json(teamMembers));
});

const getEntityTeamTicket = rest.get(
  `${apiUrl}/api/manage/team/ticket`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(teamMembers));
  }
);

const getTicketTags = rest.get(
  `${apiUrl}/api/manage/tags/:entityName/ticket`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json([]));
  }
);

const getTicketSources = rest.get(
  `${apiUrl}/api/ticket/:entityName/sources`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json([]));
  }
);

const getLinearDetail = rest.get(
  `${apiUrl}/api/linear/:entityName/issues/:ticketId`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json([]));
  }
);

const getJiraDetail = rest.get(
  `${apiUrl}/api/jira/:entityName/issues/:ticketId`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json([]));
  }
);

const getMacrosCategories = rest.get(
  `${apiUrl}/api/manage/macros/:entityName/categories`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        totalCount: 0,
        categories: [],
      })
    );
  }
);

const getMacros = rest.get(
  `${apiUrl}/api/manage/macros/:entityName`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json([]));
  }
);

const getWidgetConfig = rest.get(
  `${apiUrl}/api/manage/widgetConfig/:entityName`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(widgetConfig));
  }
);

const getRole = rest.get(`${apiUrl}/api/role/:entityName`, (req, res, ctx) => {
  return res(
    ctx.status(200),
    ctx.json([
      {
        _id: "65c2082a8527f55d9f013bdf",
        name: "Admin",
      },
    ])
  );
});

const getWebsiteOptInConfig = rest.get(
  `${apiUrl}/api/manage/websiteOptInConfig/:entityName`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json([]));
  }
);

const getProfile = rest.get(
  `${apiUrl}/api/manage/profile/:entityName`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json({}));
  }
);

export const manageMocks = [
  getStatsCount,
  getTicketTypes,
  getTags,
  getOnchainData,
  getAuthCheck,
  getAuthInfo,
  getNonce,
  signInTeamAddress,
  signInTeam,
  getEntityEcosystem,
  getEntityConfig,
  getEntityTeam,
  getEntityTeamTicket,
  getTicketTags,
  getTicketSources,
  getLinearDetail,
  getMacrosCategories,
  getMacros,
  getJiraDetail,
  getWidgetConfig,
  getRole,
  getWebsiteOptInConfig,
  getProfile,
];
